var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMap = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "8 8 14 14",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icon / Events / Location / Background")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Events-/-Location-/-Background",
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5004,4.8591 C9.5004,7.2661 5.0004,13.5001 5.0004,13.5001 C5.0004,13.5001 0.5004,7.2661 0.5004,4.8591 C0.5004,2.4511 2.5154,0.5001 5.0004,0.5001 C7.4844,0.5001 9.5004,2.4511 9.5004,4.8591",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5004,4.8591 C9.5004,7.2661 5.0004,13.5001 5.0004,13.5001 C5.0004,13.5001 0.5004,7.2661 0.5004,4.8591 C0.5004,2.4511 2.5154,0.5001 5.0004,0.5001 C7.4844,0.5001 9.5004,2.4511 9.5004,4.8591 Z",
    id: "Stroke-3",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4497,4.5046 C3.4497,3.6486 4.1437,2.9546 5.0007,2.9546 C5.8557,2.9546 6.5507,3.6486 6.5507,4.5046 C6.5507,5.3606 5.8557,6.0546 5.0007,6.0546 C4.1437,6.0546 3.4497,5.3606 3.4497,4.5046 Z",
    id: "Stroke-7",
    stroke: "currentColor"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Map.d45f2e72.svg";
export { ForwardRef as ReactComponent };